const Loader = () => (
    <div className="fixed top-0 left-0 w-full h-full  bg-opacity-50 flex justify-center items-center">
      <div className="spinner border-t-4 border-pink-500 rounded-full w-16 h-16 animate-spin"></div>
    </div>
  );
  
  export default Loader;
  